const types = require('../../constants/actionTypes');

const fetchFailed = ({ error }) => ({
    type: types.FUNDS_FETCH_FAILED,
    payload: { error },
});

module.exports = fetchFailed;
